'use strict';

require('../../styles/sections/top-messaging.scss');